import React from 'react';
import {EnrollmentFileStatusType} from 'Enrollment/models/EnrollmentFileStatusType';

type GenelcoSpreadsheetStatusProps = {
  id: number;
  invalidRecordCount: number;
  validRecordCount: number;
  rowCount: number;
  invalidAuditCount: number;
  validAuditCount: number;
  groupWebComparisonErrorCount: number;
  isValidRecord: boolean;
};
export const GenelcoSpreadsheetStatus = ({
  id,
  invalidRecordCount,
  validRecordCount,
  rowCount,
  invalidAuditCount,
  validAuditCount,
  groupWebComparisonErrorCount,
  isValidRecord,
}: GenelcoSpreadsheetStatusProps) => {

  const getActiveClassName = (id: number,
    invalidRecordCount: number,
    validRecordCount: number,
    rowCount: number,
    invalidAuditCount: number,
    validAuditCount: number,
    groupWebComparisonErrorCount: number,
    isValidRecord: boolean ) => {
    if(id === EnrollmentFileStatusType.VALIDATION_COMPLETE )
    {
      if(rowCount === validRecordCount)
        return 'enrollment-file-status-label--successful';
      else if(rowCount === invalidRecordCount)
        return 'enrollment-file-status-label--unsuccessful';
      else if(validRecordCount > 0 && invalidRecordCount > 0)
        return 'enrollment-file-status-label--warning';
      else  
        return 'enrollment-file-status-label--unsuccessful';
    }
    else if(id == EnrollmentFileStatusType.READY_FOR_AUDIT)
    {
      return 'enrollment-file-status-label--processing-complete';
    }
    else if(id === EnrollmentFileStatusType.AUDIT_COMPLETE || id === EnrollmentFileStatusType.KICKOUT_VALIDATION_COMPLETE)
    {
      if(validRecordCount === validAuditCount)
        return 'enrollment-file-status-label--successful';
      else if(validRecordCount === invalidAuditCount)
        return 'enrollment-file-status-label--unsuccessful';
      else if(validAuditCount > 0 && invalidAuditCount > 0)
        return 'enrollment-file-status-label--warning';
      else  
        return 'enrollment-file-status-label--unsuccessful';
    }
    else if(id === EnrollmentFileStatusType.COMPLETED)
    {
      if(validAuditCount > 0)
        return 'enrollment-file-status-label--processing-complete';   
      else  
        return 'enrollment-file-status-label--unsuccessful';
    }
    else if(id === EnrollmentFileStatusType.GROUPWEB_AUDIT_COMPLETE)
    {
      if(rowCount === (validAuditCount - groupWebComparisonErrorCount))
        return 'enrollment-file-status-label--successful';
      else if(rowCount === (invalidAuditCount + groupWebComparisonErrorCount))
        return 'enrollment-file-status-label--unsuccessful';   
      else if((validAuditCount > 0 && invalidAuditCount > 0))
        return 'enrollment-file-status-label--warning';  
      else if(validAuditCount === groupWebComparisonErrorCount)
        return 'enrollment-file-status-label--unsuccessful';   
      else  
        return 'enrollment-file-status-label--unsuccessful';
    }
  };


  const getActiveIcon = (id: number,
    invalidRecordCount: number,
    validRecordCount: number,
    rowCount: number,
    invalidAuditCount: number,
    validAuditCount: number,
    groupWebComparisonErrorCount: number,
    isValidRecord: boolean ) => {
      
    if(id === EnrollmentFileStatusType.VALIDATION_COMPLETE )
    {
      if(rowCount === validRecordCount)
        return 'fas fa-check-circle upload__status status__successful';
      else if(rowCount === invalidRecordCount)
        return 'fas fa-times-circle upload__status status__unsuccessful';
      else if(rowCount !== invalidRecordCount && invalidRecordCount > 0)
        return 'fas fa-check-circle upload__status status__warning'; // warning icon
      else  
        return 'fas fa-times-circle upload__status status__unsuccessful';
    }
    else if(id == EnrollmentFileStatusType.READY_FOR_AUDIT)
    {
      return 'far fa-circle upload__status status__processing';
    }
    else if(id === EnrollmentFileStatusType.AUDIT_COMPLETE || id === EnrollmentFileStatusType.KICKOUT_VALIDATION_COMPLETE)
    {
      if(validRecordCount === validAuditCount)
        return 'fas fa-check-circle upload__status status__successful';
      else if(validRecordCount === invalidAuditCount)
        return 'fas fa-times-circle upload__status status__unsuccessful';
      else if(validAuditCount > 0 && invalidAuditCount > 0)
        return 'fas fa-exclamation-triangle upload__status status__warning'; // warning icon
      else  
        return 'fas fa-times-circle upload__status status__unsuccessful';
    }
    else if(id === EnrollmentFileStatusType.COMPLETED)
    {
      if(validAuditCount > 0)
        return 'far fa-circle upload__status status__processing'; 
      else  
        return 'fas fa-times-circle upload__status status__unsuccessful';
    }
    else if(id === EnrollmentFileStatusType.GROUPWEB_AUDIT_COMPLETE)
    {
      if(rowCount === (validAuditCount - groupWebComparisonErrorCount))
        return 'fas fa-check-circle upload__status status__successful';
      else if(rowCount === (invalidAuditCount + groupWebComparisonErrorCount))
        return 'fas fa-times-circle upload__status status__unsuccessful';   
      else if((validAuditCount > 0 && invalidAuditCount > 0))
        return 'fas fa-exclamation-triangle upload__status status__warning'; 
      else if(validAuditCount === groupWebComparisonErrorCount)
        return 'fas fa-times-circle upload__status status__unsuccessful';    
      else  
        return 'fas fa-times-circle upload__status status__unsuccessful';
    }
  };

  switch (id) {
    case EnrollmentFileStatusType.VALIDATION_COMPLETE:
      return (
        <span
          id="enrollment-file-status-label-file-upload"
          className={ isValidRecord ? 
            (
              getActiveClassName(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'enrollment-file-status-label--unsuccessful'
          }
        >
          <span className="icon upload__status"><i className={ isValidRecord ? 
            (
              getActiveIcon(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'fas fa-times-circle status__unsuccessful'
          }/></span>
          File Uploaded
        </span>
      );
    case EnrollmentFileStatusType.READY_FOR_AUDIT:
      return (
        <span
          id="enrollment-file-status-label-file-audit-in-progress"
          className={ isValidRecord ? 
            getActiveClassName(id,
              invalidRecordCount,
              validRecordCount,
              rowCount,
              invalidAuditCount,
              validAuditCount,
              groupWebComparisonErrorCount,
              isValidRecord)
            : 'enrollment-file-status-label--unsuccessful'
          }
        >
          <span className="icon"><i className={ isValidRecord ? 
            (
              getActiveIcon(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'fas fa-times-circle status__unsuccessful'
          } /></span>
          Processed
        </span>
      );
    case EnrollmentFileStatusType.AUDIT_COMPLETE:
    case EnrollmentFileStatusType.KICKOUT_VALIDATION_COMPLETE:
      return (
        <span
          id="enrollment-file-status-label-file-audit"
          className={ isValidRecord ? 
            (
              getActiveClassName(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'enrollment-file-status-label--unsuccessful'
          }
        >
        <span className="icon"><i className={ isValidRecord ? 
            (
              getActiveIcon(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'fas fa-times-circle status__unsuccessful'
          }/></span>
          Processed
        </span>
      );
    case EnrollmentFileStatusType.COMPLETED:
      return (
        <span
          id="enrollment-file-status-label-file-processing-complete"
          className={ isValidRecord ? 
            (
              getActiveClassName(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'enrollment-file-status-label--unsuccessful'
          }
        >
          <span className="icon"><i className={ isValidRecord ? 
            (
              getActiveIcon(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'fas fa-times-circle status__unsuccessful'
          }/></span>
          {validAuditCount === 0 ? 'Processed' : 'Confirmed'}
        </span>
      );
    case EnrollmentFileStatusType.GROUPWEB_AUDIT_COMPLETE:
      return (
        <span
          id="enrollment-file-status-label-file-processing-complete"
          className={ isValidRecord ? 
            (
              getActiveClassName(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'enrollment-file-status-label--unsuccessful'
          }
        >
          <span className="icon"><i className={ isValidRecord ? 
            (
              getActiveIcon(id,
                invalidRecordCount,
                validRecordCount,
                rowCount,
                invalidAuditCount,
                validAuditCount,
                groupWebComparisonErrorCount,
                isValidRecord)
            ) : 'fas fa-times-circle status__unsuccessful'
          }/></span>
          {'Confirmed'}
        </span>
      );
    case EnrollmentFileStatusType.CANCELED:
      return (
        <span id="enrollment-file-status-label-canceled" 
          className={isValidRecord ? 'enrollment-file-status-label--canceled' : 'enrollment-file-status-label--unsuccessful'}>
          Cancelled
        </span>
      );
    default:
      return null;
  }

};
